import { type ComponentProps } from 'react'
import { Button, Tooltip } from '@highlight/ui'

export interface CellHoverButtonsButtonProps extends Omit<ComponentProps<typeof Button>, 'shape' | 'children'> {
  /** Tooltip text and accessible name — one string so they can't disagree. */
  label: string
  children?: ComponentProps<typeof Button>['children']
}

/** Icon button in the hover cluster: Button's md square, secondary unless a host says otherwise. */
export function CellHoverButtonsButton({
  label,
  variant = 'secondary',
  onClick,
  ...props
}: CellHoverButtonsButtonProps) {
  return (
    <Tooltip>
      <Tooltip.Trigger
        render={
          <Button
            variant={variant}
            shape="square"
            aria-label={label}
            // The cluster sits on top of a clickable row — a button press must not
            // double as a click-through into the item's view.
            onClick={(event) => {
              event.stopPropagation()
              onClick?.(event)
            }}
            {...props}
          />
        }
      />
      <Tooltip.Content>{label}</Tooltip.Content>
    </Tooltip>
  )
}
